module.exports = __webpack_public_path__ + "static/media/BigBookSci.cff9d433.svg";